import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Observable, Subscription} from 'rxjs';
import {Chart} from 'chart.js';

@Component({
    selector: 'app-bar-chart-questionnaires-avg',
    templateUrl: './bar-chart-questionnaires-avg.component.html',
    styleUrls: ['./bar-chart-questionnaires-avg.component.css']
})

export class BarChartQuestionnairesAvgComponent implements OnInit, OnDestroy {

    getAuthState: Observable<any>;
    getDoctorState: Observable<any>;
    isAuthenticated: boolean;
    user = null;
    errorMessage = null;
    isHovered = false;
    subscription1: Subscription;
    subscription3: Subscription;
    dataSource;
    canvas: any;
    ctx: any;
    myChartQuestionnairesAvg: Chart;
    // ******************************************************************************************************************
    // seguenti righe: inizializzazione dei questionari
    // HBI, MIAH-CD, MIAH-UC, MMAS8, PATIENT-SCCAI, PATIENT-PHQ9, IBDQ, IBDDISK, CLINICAL-HBI, CLINICAL-SCCAI
    // ******************************************************************************************************************
    avgs: number[] = [];
    // ******************************************************************************************************************
    // bar chart dei questionari
    // ******************************************************************************************************************
    public barChartLabelsGlobal = ['CLINICAL-HBI','CLINICAL-SCCAI','IBDQ','MMAS8','MIAH-CD','HBI','MIAH-UC','PATIENT-SCCAI','LARS'
       /*'PATIENT-PHQ9'*/ /*'IBDDISK'*/];
    public barChartTypeGlobal = 'horizontalBar';
    public barChartLegendGlobal = true;
    public barChartDataGlobal = [
      {
        data: this.avgs, label: 'Media punteggio', backgroundColor: ['teal', 'teal','teal','teal','teal','teal', 'teal','teal','teal','teal'],
        hoverBackgroundColor: ['#066', '#066'], barThickness: 25,  // number (pixels) or 'flex'
      }
    ];
  
    constructor(private store: Store<AppState>,
                private doctorService: DoctorService,
                private snackBar: MatSnackBar) {
      this.getAuthState = this.store.select(selectAuthState);
      this.getDoctorState = this.store.select(selectDoctorState);
    }
    ngOnInit(): void {
      this.subscription3 = this.getAuthState.subscribe((state) => {
        this.isAuthenticated = state.isAuthenticated;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.errorMessage = state.errorMessage;
        this.retrievedata();
      });
    }
    ngOnDestroy(): void {
      this.subscription1.unsubscribe();
      this.subscription3.unsubscribe();
    }
  
    retrievedata() {
      this.subscription1 = this.doctorService.getQuestionnairesStats().subscribe( data => {
        console.log(data);
        this.parseData(data);
        this.canvasSetting();
        }, error => {
          if (error.status === 500) {
            localStorage.setItem('expirationTime', '0');
            console.log('SESSIONE SCADUTA');
            location.reload();
          }
        });
    }
  
    parseData(data){
      for (let element in Object.keys(data)){
        var label = this.barChartLabelsGlobal[element];
        //console.log("Element: " + label);
        //console.log("Data[element]: " + data[label]);
        var p = data[label];
        var array = p.split("-",2);
        //console.log("Array " + label + " : " + array[0] + " " + array[1]);
        this.avgs[element] = parseFloat(array[1].replace(",","."));      
      }
      console.log("Average of questionnaires: " + this.avgs);    
    }
  
    canvasSetting() {
      this.canvas = document.getElementById('myChartQuestionnairesAvg') as HTMLCanvasElement;
      this.ctx = this.canvas.getContext('2d');
      this.myChartQuestionnairesAvg = new Chart(this.ctx, {
        type: this.barChartTypeGlobal,
        data: {
          labels: this.barChartLabelsGlobal,
          datasets: this.barChartDataGlobal,
        },
        options: {
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [{
              display: true,
              stacked: false,
              ticks: {
                fontSize: 12,
                fontStyle: 'bold',
                fontFamily: 'Helvetica',
                fontColor: '#006192'
              }
            }],
            yAxes: [{
              display: true,
              stacked: false,
              ticks: {
                fontSize: 12,
                fontStyle: 'bold',
                fontFamily: 'Helvetica',
                fontColor: '#006192'
              }
            }],
          },
          legend: {
            display: true,
            position: 'top',
            labels: {
              usePointStyle: true,
              fontColor: '#006192',
              fontSize: 18,
              fontFamily: 'Helvetica',
            }
          },
          tooltips: {
            backgroundColor: '#1c1c1c',
            bodyFontSize: 18,
            titleFontSize: 18,
            cornerRadius: 5,
            caretPadding: 10
          },
          title: {
            display: true,
            text: 'Media punteggio per questionario',
            fontColor: '#006192',
            fontSize: 20,
            fontFamily: 'Helvetica',
          },
          hover: {
            mode: 'nearest',
            intersect: true
          }
        }
      });
      }
  
  }
  